import { allCountries, Region } from 'country-region-data'
import { useMemo } from 'react'
import { useCreateCompanyContext } from '../CreateCompanyContext'

const useGetProvince = () => {
    const { countries } = useCreateCompanyContext()
    const provinces = useMemo(
        () =>
            countries.reduce<Record<string, Region[]>>((acc, cur) => {
                return {
                    ...acc,
                    [cur.countryID!]: allCountries.find((ac) =>
                        ac[0].includes(cur?.name ?? ''),
                    )![2],
                }
            }, {}),
        [countries],
    )
    return provinces
}

export default useGetProvince
